<template>
    
    <div class="fullscreen-div mt-2">
        <!-- {{ medio }} -->
        <div class="card head-card">
            <div class="title-card">
                
                <h4>Programas de {{ medioT }}, medios seleccionados: {{ (mediaArr.length + mediaArr2.length)==0 ?"todos": mediaArr.length + mediaArr2.length}} </h4>
                <label class="checkbox-label">
                    {{oculta? 'Ocultar':'Mostrar'}}
                    <input class="box" type="checkbox" v-model="oculta" />
                   
                </label>
                
            </div>

            <div class="card-content" v-show="oculta" >
              <!--  <div class="checkbox todoBar">
                    <label class="active todoList">
                       
                        <div class="user-avatar selectAll">
                           
                            <div class="data-avatar whiteText">Seleccionar todos</div>
                        </div>
                        <input class="box" type="checkbox" :checked="allCheck2" @click="selectAllfav()" />

                        <span class="nbox">
                            <svg viewBox="0 0 14.018 13.003">
                                <path id="Rectángulo_9" data-name="Rectángulo 9"
                                    d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                                    transform="translate(-304.98 -380.994)" fill="#fff" />
                            </svg>
                        </span>
                    </label>
                </div>
                -->
                <!-- <div class="row"> -->
                <div class="row">
                    <div class="checkbox image col-md-6 col-sm-12 col-lg-4" v-for="(item, index) in data2"
                        v-bind:key="item.key">
                        <label :for="item.key">
                            <div class="btn-img">
                                <!--<img :src="getImage(item)" />-->
                                <img :src="getImage(item)" @error="replaceByDefault" class="avatarMin" /><!--NAYE-->
                            </div>
                            <input class="box" type="checkbox" :id="item.key" :value="item.key"
                                :checked="findID(item.key) || allCheck2" @click="selectMediaFavs(item.key, $event)" />
                            {{
                    item.nombre.length > 15
                        ? item.nombre.slice(0, 15) + "..."
                        : item.nombre
                }}
                            <span class="nbox">
                                <svg viewBox="0 0 14.018 13.003">
                                    <path id="Rectángulo_9" data-name="Rectángulo 9"
                                        d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                                        transform="translate(-304.98 -380.994)" fill="#fff" />
                                </svg>
                            </span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
       
        <div class="card head-card mt-2" v-show="oculta" >
            <div class="title-card">
                <h4>{{ title }}</h4>
            </div>
            <div class="card-content"  >
                <!-- {{ mediaArr }}-->
                <div class="checkbox todoBar">
                    <label class="active todoList">
                        <div class="user-avatar selectAll">
                            <div class="data-avatar whiteText">Todo</div>
                        </div>
                        <input class="box" type="checkbox" :checked="allCheck" @click="selectAll()" />

                        <span class="nbox">
                            <svg viewBox="0 0 14.018 13.003">
                                <path id="Rectángulo_9" data-name="Rectángulo 9"
                                    d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                                    transform="translate(-304.98 -380.994)" fill="#fff" />
                            </svg>
                        </span>
                    </label>
                </div>
                <div class="row">
                    <div class="checkbox image col-md-6 col-sm-12 col-lg-4" v-for="(item, index) in data"
                        v-bind:key="item.key">
                        <label :for="item.key">
                            <div class="btn-img">
                                <img :src="getImage(item)" @error="replaceByDefault" class="avatarMin" /><!--NAYE-->
                                <!-- naye--->
                            </div>
                            <input class="box" type="checkbox" :id="item.key" :value="item.key"
                                :checked="findID(item.key) || allCheck" @click="selectMedia(item.key, $event)" />
                            {{ item.nombre.length > 15 ? item.nombre.slice(0, 15) + '...' : item.nombre }}
                            <span class="nbox">
                                <svg viewBox="0 0 14.018 13.003">
                                    <path id="Rectángulo_9" data-name="Rectángulo 9"
                                        d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                                        transform="translate(-304.98 -380.994)" fill="#fff" />
                                </svg>
                            </span>
                        </label>
                    </div>
                </div>
                <div class="button-circle-more primary" v-if="more" @click="getMore(tMedia)">
                    <button class="circle-more">
                        <svg viewBox="0 0 18 18">
                            <g id="Grupo_29" data-name="Grupo 29" transform="translate(-171 -753)">
                                <rect id="Rectángulo_redondeado_903" data-name="Rectángulo redondeado 903" width="2"
                                    height="18" rx="1" transform="translate(179 753)" />
                                <rect id="Rectángulo_redondeado_903_copia" data-name="Rectángulo redondeado 903 copia"
                                    width="18" height="2" rx="1" transform="translate(171 761)" />
                            </g>
                        </svg>
                    </button>
                </div>
            </div>
        </div>
  
    </div>

</template>
<script>
import tmedia from "@/components/busquedaAvanzada/tmedia.vue";

export default {
    components: { tmedia },
    props: ["media","programasSeleccionados","fiparamsCreate"],
    data() {
        return {
            url: this.$store.getters.getMainUrl,
            oculta : false,
            medioT: "",
            data: [],
            data2: [],
            mediaArr: [],
            mediaArr2: [],
            mediaJoin: [],
            fiParams: [1, 1],
            title: "",
            title2: "",
            allCheck: false,
            more: false,
            more2: false,
            allCheck2: false,
            lek2: null,
            lek: null,
            tMedia: "",
            pd: false,
            conteoSelect : 0,
           
        };
    },
    mounted() {
        console.log(this.media, "medios en programas");
        if (this.$store.state.notificationWhatsApp.fuentes.hasOwnProperty(this.media)) {
            this.mediaArr = this.$store.state.notificationWhatsApp.fuentes[this.media];
            
            this.mediaJoin =  this.mediaArr;
            this.addfiParams();
        }
        
        this.mostrarMedio();
    },
    computed: {
        token() {
            return this.$store.getters.getToken;
        },
        providerID() {
            return this.$store.state.userInfo.net;
        },
        userVisible() {
            if (this.dataUser.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        allCheckFn() {
            if (this.mediaArr.length > 0) {
                return false;
            } else {
                return true;
            }
        }
    },
    methods: {
        getMoreFav(mediaType) {
            switch (mediaType) {
                case "T":
                    this.getTfavs("T");

                    break;

                case "TK":
                    this.getTfavs("TK");

                    break;

                case "R":
                    this.getNFavs("R");
                    break;
                case "PD":
                    this.getNFavs("PD");
                    break;
                case "FB":
                    this.getNFavs("FB");
                    break;

                    case "TW":
                    this.getNFavs("TW");
                    break;
                case "Y":
                    this.getNFavs("Y");
                    break;
                case "I":
                    this.getNFavs("I");
                    break;
                    case "BN":
                    this.getNFavs("BN");
                    break;

                default:
                    break;
            }
        },
        getMoreMediOnline(mediaType) {
            let medioOnline = "";
            switch (mediaType) {
                case "TW":
                    medioOnline= "Twitter";
                    break;
                case "FB":
                  
                medioOnline=  "Facebook";

                    break;
                case "Y":
                    // this.mediosMostrar.push(' Youtube')
                    medioOnline=  "Youtube";

                    break;
                case "PD":
                    // this.mediosMostrar.push(' Periodico Digital')
                    medioOnline=  "Periodico Digital";

                    break;
                case "T":
                    // this.mediosMostrar.push(' Televisión')
                    medioOnline= "Televisión";

                    break;
                case "R":
                    // this.mediosMostrar.push(' Radio')
                    medioOnline= "Radio";

                    break;
                case "TK":
                    // this.mediosMostrar.push(' Tiktok')
                    medioOnline= "Tiktok";

                    break;

                default:
                    break;
            }

            return medioOnline;
        },
        mostrarMedio() {
            switch (this.media) {
                case "TW":
                    this.medioT = " Twitter";
                    break;
                case "FB":
                    // this.mediosMostrar.push(' Facebook')
                    this.medioT = " Facebook";

                    break;
                case "Y":
                    // this.mediosMostrar.push(' Youtube')
                    this.medioT = " Youtube";

                    break;
                case "PD":
                    // this.mediosMostrar.push(' Periodico Digital')
                    this.medioT = " Periodico Digital";

                    break;
                case "T":
                    // this.mediosMostrar.push(' Televisión')
                    this.medioT = " Televisión";

                    break;
                case "R":
                    // this.mediosMostrar.push(' Radio')
                    this.medioT = " Radio";

                    break;
                case "TK":
                    // this.mediosMostrar.push(' Tiktok')
                    this.medioT = " Tiktok";

                    break;

                default:
                    break;
            }

        },
        getTfavs(type) {
          
            var that = this;
            if (this.more2 == true) {
                var dat = JSON.stringify({
                    limit: 20,
                    medio: type,
                    token: that.token,
                    LastEvaluatedKey: that.lek2,

                });
            } else {
                var dat = JSON.stringify({
                    limit: 20,
                    medio: type,
                    token: that.token
                });
            }
            console.log(type);
            axios
                .post(
                    that.url + "getNoticierosFavUser",
                    dat
                )
                .then(function (response) {

                    that.data2 = _.concat(that.data2, response.data.result);
                    // that.data = response.data.result;

                    that.removeSame();

                    console.log(that.data2);

                    if (response.data.LastEvaluatedKey) {
                        that.lek2 = response.data.LastEvaluatedKey;
                        that.more2 = true;
                        that.tMedia = type;
                    } else {
                        that.lek2 = null;
                        that.more2 = false;
                    }
                })
                .catch(function (error) {
                    console.log("Error");
                    console.log(error);
                });
        },
        removeSame() {
            
            var that = this;
            for (let i = 0; i < that.data2.length; i++) {
                var key = that.data2[i].key;
                let index = _.findIndex(that.data, function (o) { return o.key == key; });

                if (index > -1) {
                    that.data.splice(index, 1);
                }
            }
        },
        getTmedia(type) {
          
            var that = this;

            if (this.more == true) {
                var dat = JSON.stringify({
                    limit: 20,
                    medio: type,
                    LastEvaluatedKey: that.lek
                });
            } else {
                var dat = JSON.stringify({
                    limit: 20,
                    medio: type
                });
            }

            console.log(type);
            axios
                .post(
                    that.url + "getProgramas",
                    dat
                )
                .then(function (response) {
                    console.log(response.data.result);
                    that.data = _.concat(that.data, response.data.result);
                    // that.data = response.data.result;
                    console.log('that.more', that.more);
                    if (that.more != true) {
                        that.getTfavs(type);
                    } else {
                        that.removeSame();
                    }
                    console.log(that.data);
                    if (response.data.LastEvaluatedKey) {
                        that.lek = response.data.LastEvaluatedKey;
                        that.more = true;
                        that.tMedia = type;
                    } else {
                        that.lek = null;
                        that.more = false;
                    }
                })
                .catch(function (error) {
                    console.log("Error");
                    console.log(error);
                });
        },
        getMediosOnline(type) {
            var that = this;
            if (this.more == true) {
                var dat = JSON.stringify({
                    feed: type,
                    limit: 20,
                    LastEvaluatedKey: that.lek
                });
            } else {
                var dat = JSON.stringify({
                    feed: type,
                    limit: 20,
                });
            }
            axios
                .post(
                     that.url + "getSourceFeeds",
                    dat
                )
                .then(function (response) {
                    console.log(response.data.result);
                    that.data = _.concat(that.data, response.data.result);
                    // that.data = response.data.result;
                    console.log('that.more', that.more);
                    if (that.more != true) {
                       // that.getTfavs(type);
                    } else {
                      //  that.removeSame();
                    }
                    console.log(that.data);
                    if (response.data.LastEvaluatedKey) {
                        that.lek = response.data.LastEvaluatedKey;
                        that.more = true;
                        that.tMedia = type;
                    } else {
                        that.lek = null;
                        that.more = false;
                    }
                })
                .catch(function (error) {
                    console.log("Error");
                    console.log(error);
                });
        },
        getPortalesmedia(type) {
            var that = this;
            if (this.more == true) {
                var dat = JSON.stringify({
                    limit: 20, 
                    LastEvaluatedKey: that.lek 
                });
            } else {
                var dat = JSON.stringify({
                    limit: 20,
                });
            }
            axios
                .post(
                    that.url + "getRSSsrc",
                    dat
                )
                .then(function (response) {
                    console.log(response.data.result);
                    that.data = _.concat(that.data, response.data.result);
                    // that.data = response.data.result;
                    console.log('that.more', that.more);
                    if (that.more != true) {
                       //that.getTfavs(type);
                    } else {
                      //  that.removeSame();
                    }
                    console.log(that.data);
                    if (response.data.LastEvaluatedKey) {
                        that.lek = response.data.LastEvaluatedKey;
                        that.more = true;
                        that.tMedia = type;
                    } else {
                        that.lek = null;
                        that.more = false;
                    }
                })
                .catch(function (error) {
                    console.log("Error");
                    console.log(error);
                });
        },
        getImage(item) {
            if (item.imagen) {
                return item.imagen;
            } else {
                return item.img;
            }
        },
        replaceByDefault(e) {
            var img = this.$store.state.defaultNote;
            console.log("333333333/******3**3*3**3*")
            console.log(this.media)
            switch (this.media) {
                case 'T': img = this.$store.state.defaultTV; break;
                case 'R': img = this.$store.state.defaultRadio; break;
                case 'PD': img = this.$store.state.defaultPD; break;
                case 'FB': img = this.$store.state.defaultFacebook; break;
                case 'TW': img = this.$store.state.defaultTwitter; break;
                case 'Y': img = this.$store.state.defaultYoutube; break;
                case 'I': img = this.$store.state.defaultInstagram; break;
                case 'TK': img = this.$store.state.defaultTiktok; break;
                default: img = this.$store.state.defaultImage; break;
                this.$store.state.defaultYoutube;
            }
            e.target.src = img;
        },
        findID(id) {
            /*console.log('findID');
            console.log(this.$store.state.projectConfig.fiList[this.media]);
            console.log(id);*/
            if (this.$store.state.notificationWhatsApp.fuentes.hasOwnProperty(this.media)) {
            if (this.$store.state.notificationWhatsApp.fuentes[this.media].indexOf(id) >= 0) {
                return true;
            } else {
                return false;
            }
        }else{
            return false;
        }
            /*var found = this.mediaJoin.find(function(element) {
              console.log('element',element);
              if (element == id) {
                return true;
              } else {
                return false;
              }
            });
            return found;*/
        },
        findID2(id) {
            var found = this.mediaArr2.find(function (element) {
                if (element == id) {
                    return true;
                } else {
                    return false;
                }
            });
            return found;
        },
        selectAllfav() {
            if (this.allCheck2 == false) {
                this.allCheck2 = true;

                this.mediaArr2 = [];
                //join arrays
                this.mediaJoin = _.union(this.mediaArr, this.mediaArr2);
                let data = {
                    mt: this.media,
                    arr: this.mediaJoin
                };

                this.$store.commit("addMedia", data);
                this.fiParams[0] = 1;
                this.fiParams[1] = this.allCheck ? 1 : 0;
                this.addfiParams();
            } else {
                this.allCheck2 = false;
                this.mediaArr2 = [];
                //join arrays
                this.mediaJoin = _.union(this.mediaArr, this.mediaArr2);
                let data = {
                    mt: this.media,
                    arr: this.mediaJoin
                };

                this.$store.commit("addMedia", data);
                this.fiParams[0] = 0;
                this.fiParams[1] = this.allCheck ? 1 : 0;
                this.addfiParams();
            }
        },
        selectAll() {
            console.log(this.allCheck);
            if (this.allCheck == false) {
                this.allCheck = true;
                this.mediaArr = [];
                //join arrays
                this.mediaJoin = _.union(this.mediaArr, this.mediaArr2);
                let data = {
                    mt: this.media,
                    arr: this.mediaJoin
                };

                this.$store.commit("addMedia", data);
                this.fiParams[1] = 1;
                this.fiParams[0] = this.allCheck2 ? 1 : 0;
                this.addfiParams();
            } else {
                this.allCheck = false;
                this.mediaArr = [];
                //join arrays
                this.mediaJoin = _.union(this.mediaArr, this.mediaArr2);
                let data = {
                    mt: this.media,
                    arr: this.mediaJoin
                };

                this.$store.commit("addMedia", data);
                this.fiParams[1] = 0;
                this.fiParams[0] = this.allCheck2 ? 1 : 0;
                this.addfiParams();
            }
        },
        addfiParams() {
           
            this.mediaJoin = _.union(this.mediaArr, this.mediaArr2);
            let data = {
                mt: this.media,
                arr: this.mediaJoin
            };
            
            console.log(data,"44$$$$$##");
            this.fiparamsCreate(data)

        },
        getMore(mediaType) {
            
            switch (this.media) {
                case "T":
                    this.getTmedia("T");

                    break;

                case "R":
                    this.getTmedia("R");

                    break;

                case "PD":
                    this.getPortalesmedia("PD");
                    break;
                case "FB":
                    this.getMediosOnline("Facebook");
                    break;
                case "Y":
                    this.getMediosOnline("Youtube");
                    break;
                case "TW":
                    this.getMediosOnline("Twitter");
                    break;
                case "TK":
                    this.getMediosOnline("Tiktok");
                    break;
                case "I":
                    this.getMediosOnline("Instagram");
                    break;
                default:
                    break;
            }
        },
        selectMediaFavs(media, element) {
            if (this.allCheck2 == true) {
                this.allCheck2 = false;
                this.mediaArr2 = [];
                element.target.checked = true;
            }

            if (element.target.checked == true) {

                this.mediaArr2.push(media);
                this.addToStore();

                this.fiParams[0] = 0;
                this.fiParams[1] = this.allCheck ? 1 : 0;
                this.addfiParams();
            } else {
                this.removeItem2(media);
            }
        },
        addToStore() {
           
            this.mediaJoin = _.union(this.mediaArr, this.mediaArr2);
            let data = {
                mt: this.media,
                arr: this.mediaJoin
            };
            // this.$store.commit("addMedia", data);
            console.log('fiList=>>>>>>>>>', data);
            console.log('media--1', this.mediaArr);
            console.log('media2', this.mediaArr2);
            this.programasSeleccionados(data)
            
        },
        selectMedia(media, element) {
            console.log('selectMedia');
            console.log(element.target.checked);
            if (this.allCheck == true) {
                this.allCheck = false;
                this.mediaArr = [];

                element.target.checked = true;
            }

            if (element.target.checked == true) {
               
                this.mediaArr.push(media);
                this.fiParams[1] = 0;
                this.fiParams[0] = this.allCheck2 ? 1 : 0;
                this.addfiParams();
                this.addToStore();

            } else {
                console.log('removemos')
                this.removeItem(media);

            }
        },
        removeItem(media) {
            var index = this.mediaArr.indexOf(media);
            if (index > -1) {
                this.mediaArr.splice(index, 1);
            }

            this.addToStore();
        },
        removeItem2(media) {
            var index = this.mediaArr2.indexOf(media);
            if (index > -1) {
                this.mediaArr2.splice(index, 1);
            }

            this.addToStore();
        },
    },
    beforeMount() {
        //this.getTmedia(this.media);
        console.log("#########################3")
        console.log(this.media)
        if (this.media == "R" || this.media == "T" ) {
            this.getTmedia(this.media);
        }
        else if (this.media == "PD"){
           this.getPortalesmedia();
        }
        else{
           let medio = this.getMoreMediOnline(this.media)
           this.getMediosOnline(medio);
        }
       
    
    }
};
</script>
<style scoped>
.title-card {
            display: flex;
            justify-content: space-between; /* Distribuye los elementos de manera equitativa */
            align-items: center; /* Alinea verticalmente los elementos */
            padding: 10px; /* Opcional: agregar relleno interno */
            border: 1px solid #ccc; /* Opcional: agregar un borde */
        }
        .title-card h4 {
            margin: 0; /* Elimina el margen predeterminado del título */
        }
        .checkbox-label {
            color: rgb(255, 255, 255); /* Color del texto del label */
            cursor: pointer;
        }
</style>

